(function ($, njm) {
    'use strict';

    njm.views.getCommercialAutoQuote = Backbone.View.extend({

        events: {
            'click .selected': 'openSelect',
            'click #selectState a': 'selectState',
            'click #selectVehicle a': 'selectVehicle',
            'click #gotoQuote': 'navigate'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$state = $('#selectState .selected');
            this.$product = $('#selectVehicle .selected');
            this.$button = $('#gotoQuote');
            this.$linkHref = $('#gotoQuote').attr("href");
            this.$linkTarget = $('#gotoQuote').attr("target");
            this.$geoLoc = this.$('input[name=geostate]');
            this.initialProductOption = $('#selectVehicle .selected').text();
            this.selected = {
                stateIndex: 0,
                products: [],
                productIndex: 0,
                device: 'desktop'
            };
           

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.selected.device = 'mobile';
            }
            this.$button.addClass('disabled');
            if ($('#selectState a.active').length) {
                this.setState($('#selectState a.active').text());
            }
            if (this.$geoLoc.val() !== '') {
                this.setState(this.$geoLoc.val());
            }

            $('body').click(this.hideDropdown.bind(this));
        },

        /**
         * Open custom selects
         */
        openSelect: function (e) {
            var $select = $(e.currentTarget).parent();
            if (!$select.hasClass('disabled')) {
                $(e.currentTarget)
                    .parent().toggleClass('open')
                    .find('ul').slideToggle(200);
            }
        },

        /**
         * Select  State
         */
        selectState: function (e) {
            e.preventDefault();
            var $selected = $(e.currentTarget);
            this.setState($selected.text());
            this.$button.addClass('disabled');
            $('#selectVehicle span').text('Select Vehicles');
            $selected
                .addClass('active')
                .parent().siblings().children('a').removeClass('active')
                .parents('ul').slideToggle(200)
                .parent().toggleClass('open');
        },

        /**
         * Set State
         * @param {string} state
         */
        setState: function (state) {
            this.$state.text(state);
            this.$button.data('layer-state', state);
        },

        /**
         * Select  Product
         */
        selectVehicle: function (e) {
            e.preventDefault();
            var $selected = $(e.currentTarget);
            this.$product.text($selected.text());

            $selected
                .addClass('active')
                .parent().siblings().children('a').removeClass('active')
                .parents('ul').slideToggle(200)
                .parent().toggleClass('open');

            this.$button.data('layer-state', $selected.text());
            $('#selectVehicle ul').hide();
            this.loadUrl();
        },
        
        /**
        * Load URL for button
        */
        loadUrl: function () {
            this.$button
                .removeClass('disabled');
            var $selectedState = $('#selectState .selected').text();
            var $selectedVehicles = $('#selectVehicle .selected').text();
            var $conditionState = this.$button.data('state-condition');
            var $conditionVehicle = this.$button.data('vehicle-condition');
            var redirectUrl = this.$button.data('redirect-url');
            var redirectTarget = this.$button.data('redirect-target');
            if ($selectedState === $conditionState && $selectedVehicles === $conditionVehicle) {
                this.$button
                    .attr({ 'href': redirectUrl, 'target' : redirectTarget })
            }
            else {
                this.$button.attr({ 'href': this.$linkHref, 'target': this.$linkTarget })
            }
        },
        hideDropdown: function (e, target) {
            if (!$(e.target).closest('#selectState').length) {
                $('#selectState').removeClass('open').find('ul').slideUp(200);
            }
            if (!$(e.target).closest('#selectVehicle').length) {
                $('#selectVehicle').removeClass('open').find('ul').slideUp(200);
            }
        },
        /**
        * Button click
        */
        navigate: function (e) {
            if ($(this.$button).hasClass('disabled')) {
                e.preventDefault();
                return false;
            }
            else {
                var $lnkHref = $('#gotoQuote').attr("href");
                if (e.currentTarget === "#modal" || e.currentTarget === "##modal" || $lnkHref === "#modal" || $lnkHref === "##modal" ) {
                    e.preventDefault();
                    njmGenericModal.openGenericModal();
                    return false;
                }
            }
        },
    });
})(jQuery, njm);
